import 'antd/dist/reset.css';
import { AppLayout, Loading, RoutesLoader } from 'components';
import { Suspense, lazy } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import 'styles/index.scss';
import { WEBCOMPONENTS, WEBCOMPONENTSPROPS } from 'utils';
import Login from './Login';
import './i18n';

const PageRender = lazy(() => import('./Render'));

function App() {
  return (
    <div className="App">
      {!!!localStorage.getItem('refresh') ? (
        <Login />
      ) : (
        <BrowserRouter>
          <AppLayout>
            <Suspense fallback={<Loading />}>
              <RoutesLoader>
                <Route path="/" element={<PageRender />} />
                <Route path="/:page" element={<PageRender />} />
                <Route path="/:page/:slug" element={<PageRender />} />
                {WEBCOMPONENTS.map(
                  (item: WEBCOMPONENTSPROPS, index: number) => (
                    <Route
                      key={index}
                      path={item.path}
                      element={item.Component}
                    />
                  ),
                )}
              </RoutesLoader>
            </Suspense>
          </AppLayout>
        </BrowserRouter>
      )}
    </div>
  );
}
export default App;
